import { request } from "../utils/request"


/**
 * 根据关键字查询企业列表数据
 * @param params 
 * @returns 
 */
export const getGroups = (params: { cmp: number | undefined, parent: number | undefined }) => {
    return request.get(`/group`, { params })
}
/**
 * tree 数据鼠标操作同步数据到后台
 * @param data 
 * @returns 
 */
export const dragGroupOrPoint = (data: {
    type: 'after' | 'before' | 'inner' | 'none',
    dragging: { id: number, type: 'group' | 'point' },
    drop: { id: number, type: 'group' | 'point' }
}) => {
    return request.post(`/group/drag`, data)
}

/**
 * 新建文件夹
 * @param data 
 */
export const createGroup = (cmpId: number | undefined, data: { type: 'group' | 'point', id: number }) => {
    return request.post(`/group/create?${cmpId ? 'cmp=' + cmpId : undefined}`, data)
}
/**
 * 递归删除文件夹内容
 * @param data 
 * @returns 
 */
export const deleteGroupOrPoint = (data: { type: 'group' | 'point', id: number }) => {
    return request.post(`/group/delete`, data)
}

/**
 * tree数据更新名称
 * @param data 
 * @returns 
 */
export const updateGroupOrPointName = (data: { type: 'group' | 'point', id: number, name: string }) => {
    return request.post(`/group/update/name`, data)
}